var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_11",
    "data-name": "Rect\\xE1ngulo 11",
    width: 20.01,
    height: 20.35,
    transform: "translate(0 0)",
    fill: "#1c1c1c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_mail",
    transform: "translate(-322 -2924)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elipse_3",
    "data-name": "Elipse 3",
    transform: "translate(322 2924)",
    fill: "#efefed",
    stroke: "#1c1c1c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(335 2937)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M19.592,6.325a8.908,8.908,0,0,0-1.756-3.193A8.726,8.726,0,0,0,14.717.849,10.822,10.822,0,0,0,10.281,0,10.925,10.925,0,0,0,6.008.807,9.579,9.579,0,0,0,2.762,3.029,9.885,9.885,0,0,0,.711,6.28,10.764,10.764,0,0,0,0,10.175,10.331,10.331,0,0,0,.78,14.2a9.937,9.937,0,0,0,5.381,5.381,10.119,10.119,0,0,0,3.935.767,10.8,10.8,0,0,0,2.946-.413,10.113,10.113,0,0,0,2.451-1.066.646.646,0,0,0,.234-.858l-.1-.192a.652.652,0,0,0-.4-.321.631.631,0,0,0-.5.065,8.258,8.258,0,0,1-1.939.806,8.881,8.881,0,0,1-5.9-.293,8.522,8.522,0,0,1-2.707-1.839,8.752,8.752,0,0,1-1.826-2.728,8.339,8.339,0,0,1-.661-3.31,9.062,9.062,0,0,1,.572-3.174A8.584,8.584,0,0,1,3.936,4.268,8.021,8.021,0,0,1,6.625,2.331a8.825,8.825,0,0,1,3.656-.719,9.392,9.392,0,0,1,3.455.6,7.217,7.217,0,0,1,2.59,1.72A7.075,7.075,0,0,1,17.911,6.6a9.224,9.224,0,0,1,.405,3.479,4.729,4.729,0,0,1-.411,1.759,2.736,2.736,0,0,1-.884,1.081,2.052,2.052,0,0,1-1.182.365,1.956,1.956,0,0,1-1.653-.607,2.488,2.488,0,0,1-.479-1.525V7.637a.651.651,0,0,0-.65-.65h-.231a.65.65,0,0,0-.6.409,2.791,2.791,0,0,0-.584-.318A4.483,4.483,0,0,0,7.8,7.17,3.444,3.444,0,0,0,6.444,8.525a4.125,4.125,0,0,0-.49,2.047,4.122,4.122,0,0,0,.475,1.992,3.464,3.464,0,0,0,1.332,1.368,4.453,4.453,0,0,0,3.977.042,2.944,2.944,0,0,0,.848-.59,2.99,2.99,0,0,0,.812.859,3.886,3.886,0,0,0,2.308.655,3.855,3.855,0,0,0,2.909-1.243A6.08,6.08,0,0,0,19.979,9.9a9.573,9.573,0,0,0-.387-3.58M9.805,12.784a2.318,2.318,0,0,1-1.639-.557,2.15,2.15,0,0,1-.6-1.681,2.3,2.3,0,0,1,.575-1.689,2.26,2.26,0,0,1,1.663-.575,2.272,2.272,0,0,1,1.6.564,2.19,2.19,0,0,1,.612,1.7,2.169,2.169,0,0,1-.6,1.659,2.234,2.234,0,0,1-1.612.579",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/_mail.e730dcfa636f4893a57320290388be44.svg";
export { ForwardRef as ReactComponent };